<!-- Hover buttons -->
<div *ngIf="features.hover.cvat" (click)="launchInCVAT()">
  <ng-content select="[action='cvat']"></ng-content>
</div>

@if (annotationCount() > 0) {
  <div #annotationsTrigger>
    <fw-badge color="primary" [value]="annotationCount().toString()">
      <ng-content select="[action='annotations']"></ng-content>
    </fw-badge>
  </div>
  <fw-popover
    (isOpenChange)="forceVisible = $event"
    [trigger]="annotationsTrigger"
    action="click"
    position="left-below">
    <app-annotation-list [fileId]="file.file_id"></app-annotation-list>
  </fw-popover>
}

<div *ngIf="(viewable$ | async) && features.hover.view" (click)="viewInApp()">
  <ng-content select="[action='view']"></ng-content>
</div>
<div *ngIf="features.hover.info" (click)="information()">
  <ng-content select="[action='info']"></ng-content>
</div>
<div *ngIf="features.hover.download" (click)="download()">
  <ng-content select="[action='download']"></ng-content>
</div>
<!-- Kabob menu -->
<div *ngIf="showKabobMenu" fwMenuCloseTriggers>
  <div [cdkMenuTriggerFor]="menu">
    <ng-content></ng-content>
  </div>
  <ng-template #menu>
    <fw-menu-container>
      <fw-menu>
        <fw-menu-item *ngIf="features.kabob.info" [title]="'common.actions.information' | translate" (click)="information()"></fw-menu-item>
        <fw-menu-item *ngIf="features.kabob.download" [title]="'common.actions.download' | translate" (click)="download()"></fw-menu-item>
        <fw-menu-item *ngIf="features.kabob.delete" [title]="'common.actions.delete' | translate" (click)="delete()"></fw-menu-item>
        <fw-menu-item *ngIf="features.kabob['version-history']" [title]="'fileActions.labels.versionHistory' | translate" (click)="versionHistory()"></fw-menu-item>
        <fw-menu-item *ngIf="features.kabob['copy-filename']" [title]="(showingFileNameCopy ? 'fileActions.labels.copyFileName' : 'fileActions.labels.copied') | translate" (click)="showingFileNameCopy = false; copyToClipboard(file.name)">
          <fw-icon *ngIf="!showingFileNameCopy">done-check</fw-icon>
        </fw-menu-item>
        <fw-menu-item *ngIf="features.kabob['copy-modality']" [title]="(showingModalityCopy ? 'fileActions.labels.copyModality' : 'fileActions.labels.copied') | translate" (click)="showingModalityCopy = false; copyToClipboard(modalityDisplay)">
          <fw-icon *ngIf="!showingModalityCopy">done-check</fw-icon>
        </fw-menu-item>

        <ng-container *ngIf="features.kabob.tasks">
          <fw-menu-separator></fw-menu-separator>
          <fw-menu-item title="Create Reader Task" (click)="createReaderTask()"></fw-menu-item>
        </ng-container>

        <ng-container *ngVar="{viewable: viewable$ | async, viewerApps: viewerApps$ | async} as data">
          <ng-container *ngIf="data.viewable && features.kabob.view">
            <fw-menu-separator></fw-menu-separator>
            <ng-container *ngIf="data.viewerApps?.length > 0; else standardViewer">
              <fw-menu-item *ngFor="let app of data.viewerApps" [title]="'common.actions.launchIn' | translate | interpolate:app.name" (click)="viewInApp(app)"></fw-menu-item>
            </ng-container>
            <ng-template #standardViewer>
              <fw-menu-item [title]="'common.actions.launch' | translate" (click)="viewInApp()"></fw-menu-item>
            </ng-template>
          </ng-container>
        </ng-container>
      </fw-menu>
    </fw-menu-container>
  </ng-template>
</div>
